export default {
    gradePrimaria: [],
    gradeSecundaria: [],
    gradePrimariaSelecionadaId: null,
    gradeSecundariaSelecionadaId: null,
    qtdEstoque: 0
}